module.exports = __webpack_public_path__ + "res/ic_declare_winner.cee1a8f13fd944007f5546aeec605466.png";